export default __webpack_public_path__ + "static/media/team_icon.56899435.svg";